import { FetchError } from "@/@types/fetch";

export const fetcher = (...args: Parameters<typeof fetch>) =>
  fetch(...args)
    .then((res) => res.json())
    .then(res => {
      if(res.error) {
          throw new FetchError(res.error);
      }
      return res
    })
